import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickResult } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';

export const getOneClickReceivingPersonsState = createSelector(
  getOneClickState,
  state => state.receivingPersonState,
);

export const getOneClickReceivingPersons = createSelector(
  getOneClickReceivingPersonsState,
  state => state.receivingPeopleAvailable,
);

export const getOneClickReceivingPersonsSelected = createSelector(
  getOneClickReceivingPersonsState,
  state => state.selected,
);

export const receivingPersonWithOrder = createSelector(
  getOneClickReceivingPersons,
  getOneClickResult,
  getOneClickState,
  (receivingPersons, order, oneClickState) => ({ receivingPersons, order, oneClickState }),
);

export const getOneClickAddingReceivingPerson = createSelector(
  getOneClickState,
  state => state.oneClickOrders.addingReceivingPerson,
);
